import {
  Children,
  PropsWithChildren,
  SyntheticEvent,
  cloneElement,
  isValidElement,
} from 'react';
import styled from 'styled-components';

import { ButtonVariant } from 'components/Button/Button.types';

type ButtonGroupProps = {
  className?: string;
  value: string;
  onSelected: (e: SyntheticEvent) => void;
};

export const ButtonGroup = styled(
  ({
    children,
    className,
    value,
    onSelected,
  }: PropsWithChildren<ButtonGroupProps>) => {
    const onClick = (e: SyntheticEvent) => {
      if (onSelected) {
        onSelected(e);
      }
    };

    return (
      <div className={className}>
        {Children.map(children, (child) => {
          if (
            !isValidElement<{
              id: string;
              onClick: (e: SyntheticEvent) => void;
              variant: ButtonVariant;
            }>(child)
          ) {
            return child;
          }

          return cloneElement(child, {
            onClick: value !== child.props.id ? onClick : undefined,
            variant:
              value !== child.props.id ? 'inactive' : child.props.variant,
          });
        })}
      </div>
    );
  },
)`
  > * {
    border-radius: 8px 0 0 8px;

    &:first-child {
      border-radius: 8px 0 0 8px;
    }

    &:last-child {
      border-radius: 0 8px 8px 0;
    }
  }
`;
